module.exports = __webpack_public_path__ + "img/Flag_of_Paraguay.8156f5f7.svg";